import { PaginationItem as MuiPaginationItem } from '@mui/material';
import { styled } from '@mui/material/styles';

export const PaginationItem = styled(MuiPaginationItem)(
  ({ theme, type, disabled, selected }) => ({
    ...theme.typography.body2Redesign,
    backgroundColor: theme.palette.common.white,
    color: theme.palette.text.primary,
    borderColor: theme.palette.grayscale[300],
    ...(selected && {
      backgroundColor: `${theme.palette.primaryColorShades.p12} !important`,
      borderColor: `${theme.palette.primaryColorShades.p50} !important`,
      color: theme.palette.primary.main,
    }),
    ...(['next', 'previous'].includes(type) &&
      disabled && {
        color: theme.palette.grayscale[500],
        borderColor: theme.palette.grayscale[300],
      }),
  })
);
